import styled from 'styled-components';
import { EmojiClickData } from 'emoji-picker-react';
import KubitTooltip from '../../../../KubitTooltip';
import { SvgIcon } from '../../../../Icon';
import EmojiPicker from '../../../ConversationInput/EmojiPicker';
import { theme } from '../../../../../styles/theme';

interface IProps {
  onSelect: (emojiData: EmojiClickData) => void;
  onOpen: () => void;
  onClose: () => void;
}

const EmojiPickerContainer = styled(EmojiPicker)`
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 4px;
  &:hover {
    background-color: ${theme.colors.grayscale300};
    cursor: pointer;
  }
`;

const AddCommentReaction = ({ onSelect, onOpen, onClose }: IProps) => {
  return (
    <KubitTooltip content={'Add reaction'} placement="bottom">
      <EmojiPickerContainer
        onSelect={onSelect}
        onOpen={onOpen}
        onClose={onClose}
        placement="bottom"
        reactionsDefaultOpen={true}
      >
        <SvgIcon name="smiley-reaction" width={20} height={20} />
      </EmojiPickerContainer>
    </KubitTooltip>
  );
};

export default AddCommentReaction;
